const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch('/api/drive/upload', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Upload failed');
    }

    return await response.json();
  } catch (error) {
    throw new Error('Failed to upload file');
  }
};

const getFiles = async () => {
  try {
    const response = await fetch('/api/drive/files');
    if (!response.ok) {
      throw new Error('Failed to fetch files');
    }
    return await response.json();
  } catch (error) {
    throw new Error('Failed to get files');
  }
};

const deleteFile = async (fileId) => {
  try {
    const response = await fetch(`/api/drive/files/${fileId}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete file');
    }
    return await response.json();
  } catch (error) {
    throw new Error('Failed to delete file');
  }
};

export { uploadFile, getFiles, deleteFile };
